import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { useAdminPermission } from "../../adminPermission";
import axios from "axios";
import "./updatingStudentData.css";
import Logo from "../../../public_directory/public-routes-images/logos/Manga_Cons _Logo2.png";

import IsLoading from "../../../../isLoading";
// import from MUI
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import MailIcon from "@mui/icons-material/Mail";
import LockResetIcon from "@mui/icons-material/LockReset";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

let deletedData;

function getAtPath(obj, path) {
  return path.reduce(
    (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
    obj,
  );
}

function setAtPath(obj, path, value) {
  let cur = obj;
  for (let i = 0; i < path.length - 1; i++) {
    const k = path[i];
    if (cur[k] === undefined) cur[k] = {};
    cur = cur[k];
  }
  cur[path[path.length - 1]] = value;
}

function EditableField({ value, type, onSave }) {
  const [editing, setEditing] = useState(false);
  const [v, setV] = useState(value ?? "");

  function switchInputType() {
    switch (type) {
      case "textarea":
        return (
          <textarea
            value={v}
            onChange={(e) => setV(e.target.value)}
            style={{ minWidth: "20rem", minHeight: "5rem" }}
          />
        );
      case "level":
        return (
          <select value={v} onChange={(e) => setV(e.target.value)}>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="300">300</option>
          </select>
        );
      case "session":
        return (
          <select value={v} onChange={(e) => setV(e.target.value)}>
            <option value="2024/2025">2024/2025</option>
            <option value="2025/2026">2025/2026</option>
            <option value="2026/2027">2026/2027</option>
            <option value="2027/2028">2027/2028</option>
            <option value="2028/2029">2028/2029</option>
            <option value="2029/2030">2029/2030</option>
          </select>
        );
      case "semester":
        return (
          <select value={v} onChange={(e) => setV(e.target.value)}>
            <option value="First Semester">First Semester</option>
            <option value="Second Semester">Second Semester</option>
          </select>
        );
      default:
        return (
          <input type={type} value={v} onChange={(e) => setV(e.target.value)} />
        );
    }
  }

  useEffect(() => setV(value ?? ""), [value]);

  return (
    <span style={{ display: "flex", alignItems: "center", gap: ".6rem" }}>
      {!editing ? (
        <>
          <span>{value ?? ""}</span>
          <button
            className="edit-button fx-ac fx-jc"
            style={{
              color: "#007bff",
              background: "transparent",
            }}
            onClick={() => setEditing(true)}
          >
            <EditRoundedIcon style={{ fontSize: "1.8rem" }} />
          </button>
        </>
      ) : (
        <div className="editingCont fx-cl fx-jc spacem">
          {switchInputType()}

          <aside className="fx-ac fx-jb space2">
            <button
              className="save-button fx-ac fx-jc"
              style={{
                background: "#00c851",
                color: "#fff",
                border: "none",
                padding: ".2rem .6rem",
                borderRadius: ".4rem",
              }}
              onClick={() => {
                setEditing(false);
                onSave(v);
              }}
            >
              Save
            </button>
            <button
              className="cancel-button fx-ac fx-jc"
              style={{
                background: "#e44c4c",
                color: "#fff",
                border: "none",
                padding: ".2rem .6rem",
                borderRadius: ".4rem",
              }}
              onClick={() => {
                setV(value ?? "");
                setEditing(false);
              }}
            >
              Cancel
            </button>
          </aside>
        </div>
      )}
    </span>
  );
}

export default function UpdateStudentData() {
  const adminPermission = useAdminPermission();

  const deleteStudent = async (adm) => {
    if (!window.confirm("Are you sure you want to delete this student?")) {
      console.log("Deletion cancelled");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.delete(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/administration/students/${encodeURIComponent(adm)}/delete_student`,
      );

      deletedData = response.data.deletedData;

      enqueueSnackbar(response.data.message, {
        variant: response.data.status === 201 ? "success" : "warning",
        autoHideDuration: 3000,
        ContentProps: {
          style: {
            fontSize: "16px",
            fontWeight: "bold",
          },
        },
      });

      setLoading(false);
    } catch (err) {
      console.log(err.response?.data || err);
      setLoading(false);
    }
  };

  const staffID = useSelector(
    (state) => state.adminFunction.queue.adminData?.staffId,
  );
  const { enqueueSnackbar } = useSnackbar();
  const { adm } = useParams();
  const encodedId = encodeURIComponent(adm);
  const [loading, setLoading] = useState(false);
  const [updatingStudentData, setupdatingStudentData] = useState(null);
  const redirect = useNavigate();

  async function getupdatingStudentData() {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/management/fetchStudentData/${encodedId}`,
      );
      const d = response?.data?.data;
      setupdatingStudentData(d);
      if (response?.data?.status === 201) {
        enqueueSnackbar(`${response?.data.message}`, {
          variant: "success",
          autoHideDuration: 3000,
        });
      } else if (response?.data?.status === 404) {
        enqueueSnackbar(`${response?.data.message}`, {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }

  async function persistData(newData) {
    try {
      await axios.put(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/administration/students/${encodedId}/editing_student_content`,
        newData,
      );
      enqueueSnackbar(`Saved`, { variant: "success", autoHideDuration: 2000 });
    } catch (err) {
      console.log(err);
      enqueueSnackbar(`Save failed`, {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  }

  function handleFieldSave(pathArray, newValue) {
    setupdatingStudentData((prev) => {
      const next = JSON.parse(JSON.stringify(prev || {}));
      setAtPath(next, pathArray, newValue);
      persistData(next);
      return next;
    });
  }

  useEffect(() => {
    getupdatingStudentData();
  }, []);

  if (loading || !updatingStudentData) return <IsLoading />;

  const data = updatingStudentData;

  return (
    <div className="updatingStudentDataPreviewCont">
      <div className="updatingStudentDataPr fx-cl space1">
        <div className="updatingStudentDataPrHeader fx-ac fx-jc space4">
          <figure>
            <img src={Logo} alt="logo" />
          </figure>
          <div className="fx-cl fx-jc spacem">
            <h2 className="fs6">MANGA COLLEGE OF NURSING SCIENCES, ZURU</h2>
            <p className="fs4">
              P.M.B. 02 Zuru-Kontagora Road Amanawa Area, Zuru, Kebbi State
              -Nigeria
            </p>
            <strong className="fs5">
              Administrative Student Data Edit (Editable)
            </strong>
          </div>
        </div>

        <div className="fx-jb space3">
          <div className="updatingStudentDataPrcomp g g3 space2">
            <div>
              <strong>Student ID:</strong>{" "}
              {adminPermission.fullControll && (
                <EditableField
                  value={data?.admission_number}
                  onSave={(v) => handleFieldSave(["admission_number"], v)}
                />
              )}
            </div>
            <div>
              <strong>First Name:</strong>{" "}
              <EditableField
                value={getAtPath(data, ["personalInfo", "first_Name"])}
                onSave={(v) =>
                  handleFieldSave(["personalInfo", "first_Name"], v)
                }
              />
            </div>
            <div>
              <strong>Surname:</strong>{" "}
              <EditableField
                value={getAtPath(data, ["personalInfo", "sur_Name"])}
                onSave={(v) => handleFieldSave(["personalInfo", "sur_Name"], v)}
              />
            </div>
            <div>
              <strong>Other Name:</strong>{" "}
              <EditableField
                value={getAtPath(data, ["personalInfo", "other_Name"])}
                onSave={(v) =>
                  handleFieldSave(["personalInfo", "other_Name"], v)
                }
              />
            </div>
            <div>
              <strong>Date of Birth:</strong>{" "}
              <EditableField
                type="date"
                value={
                  getAtPath(data, ["personalInfo", "Date_of_birth"])?.slice
                    ? getAtPath(data, ["personalInfo", "Date_of_birth"]).slice(
                        0,
                        10,
                      )
                    : getAtPath(data, ["personalInfo", "Date_of_birth"])
                }
                onSave={(v) =>
                  handleFieldSave(["personalInfo", "Date_of_birth"], v)
                }
              />
            </div>
            <div>
              <strong>Gender:</strong>{" "}
              <EditableField
                value={getAtPath(data, ["personalInfo", "gender"])}
                onSave={(v) => handleFieldSave(["personalInfo", "gender"], v)}
              />
            </div>
            <div>
              <strong>Marital status:</strong>{" "}
              <EditableField
                value={getAtPath(data, ["personalInfo", "Marital_status"])}
                onSave={(v) =>
                  handleFieldSave(["personalInfo", "Marital_status"], v)
                }
              />
            </div>

            <div>
              <strong>Email:</strong>{" "}
              <EditableField
                value={getAtPath(data, ["contactInfo", "email"])}
                onSave={(v) => handleFieldSave(["contactInfo", "email"], v)}
              />
            </div>
            <div>
              <strong>Phone:</strong>{" "}
              <EditableField
                value={getAtPath(data, ["contactInfo", "phone_number"])}
                onSave={(v) =>
                  handleFieldSave(["contactInfo", "phone_number"], v)
                }
              />
            </div>
            <div>
              <strong>Identity:</strong>{" "}
              <EditableField
                value={getAtPath(data, ["idCard", "status"])}
                onSave={(v) => handleFieldSave(["idCard", "status"], v)}
              />
            </div>
          </div>

          <div>
            <img
              className="updatingStudentDataPrpassport"
              src={getAtPath(data, ["personalInfo", "passport"])}
              alt="Student Passport"
              style={{ maxWidth: "10rem" }}
            />
            {adminPermission.fullControll && (
              <div style={{ marginTop: ".5rem" }}>
                <EditableField
                  value={getAtPath(data, ["personalInfo", "passport"])}
                  onSave={(v) =>
                    handleFieldSave(["personalInfo", "passport"], v)
                  }
                />
              </div>
            )}
          </div>
        </div>

        <div
          className="updatingStudentDataPrcomp g g3 space2"
          style={{ borderTop: "1px solid #ccc", paddingTop: "1.5rem" }}
        >
          <div>
            <strong>State of Origin:</strong>{" "}
            <EditableField
              value={getAtPath(data, [
                "personalInfo",
                "permanent_home_address",
                "State_of_origin",
              ])}
              onSave={(v) =>
                handleFieldSave(
                  ["personalInfo", "permanent_home_address", "State_of_origin"],
                  v,
                )
              }
            />
          </div>
          <div>
            <strong>Local Gov't Area:</strong>{" "}
            <EditableField
              value={getAtPath(data, [
                "personalInfo",
                "permanent_home_address",
                "Local_Govt_Area",
              ])}
              onSave={(v) =>
                handleFieldSave(
                  ["personalInfo", "permanent_home_address", "Local_Govt_Area"],
                  v,
                )
              }
            />
          </div>
          <div>
            <strong>Address:</strong>{" "}
            <EditableField
              type="textarea"
              value={getAtPath(data, [
                "personalInfo",
                "permanent_home_address",
                "line_address",
              ])}
              onSave={(v) =>
                handleFieldSave(
                  ["personalInfo", "permanent_home_address", "line_address"],
                  v,
                )
              }
            />
          </div>
          <div>
            <strong>Next of Kin Name:</strong>{" "}
            <EditableField
              value={getAtPath(data, [
                "contactInfo",
                "next_of_kin",
                "full_name",
              ])}
              onSave={(v) =>
                handleFieldSave(["contactInfo", "next_of_kin", "full_name"], v)
              }
            />
          </div>
          <div>
            <strong>Next of Kin address:</strong>{" "}
            <EditableField
              value={getAtPath(data, ["contactInfo", "next_of_kin", "address"])}
              onSave={(v) =>
                handleFieldSave(["contactInfo", "next_of_kin", "address"], v)
              }
            />
          </div>
          <div>
            <strong>NOK Phone No.:</strong>{" "}
            <EditableField
              value={getAtPath(data, ["contactInfo", "next_of_kin", "phone"])}
              onSave={(v) =>
                handleFieldSave(["contactInfo", "next_of_kin", "phone"], v)
              }
            />
          </div>
        </div>

        <div
          className="updatingStudentDataPrcomp g g3 space2"
          style={{ borderTop: "1px solid #ccc", paddingTop: "1.5rem" }}
        >
          {adminPermission.fullControll && (
            <div>
              <strong>Entry Session:</strong>{" "}
              <EditableField
                type="session"
                value={getAtPath(data, ["academicInfo", "entry_session"])}
                onSave={(v) =>
                  handleFieldSave(["academicInfo", "entry_session"], v)
                }
              />
            </div>
          )}

          <div>
            <strong>Department</strong>{" "}
            {adminPermission.fullControll && (
              <EditableField
                value={getAtPath(data, ["academicInfo", "department"])}
                onSave={(v) =>
                  handleFieldSave(["academicInfo", "department"], v)
                }
              />
            )}
          </div>
          <div>
            <strong>Programme of Study:</strong>{" "}
            {adminPermission.fullControll && (
              <EditableField
                value={getAtPath(data, ["academicInfo", "programme"])}
                onSave={(v) =>
                  handleFieldSave(["academicInfo", "programme"], v)
                }
              />
            )}
          </div>
          <div>
            <strong>Level:</strong>{" "}
            <EditableField
              type="level"
              value={getAtPath(data, ["academicInfo", "level"])}
              onSave={(v) => handleFieldSave(["academicInfo", "level"], v)}
            />
          </div>
          <div>
            <strong>Present Session:</strong>{" "}
            <EditableField
              type="session"
              value={getAtPath(data, ["academicInfo", "pressent_session"])}
              onSave={(v) =>
                handleFieldSave(["academicInfo", "pressent_session"], v)
              }
            />
          </div>
          <div>
            <strong>Present Semester:</strong>{" "}
            <EditableField
              type="semester"
              value={getAtPath(data, ["academicInfo", "pressent_semester"])}
              onSave={(v) =>
                handleFieldSave(["academicInfo", "pressent_semester"], v)
              }
            />
          </div>
        </div>
        {adminPermission.fullControll && (
          <div className="g g2 rwdG2 space3">
            <div className="fx-cl spacem">
              <h3>First Sitting Result</h3>
              <div className="fx-ac">
                <span>Number of Sitting:</span>
                <EditableField
                  value={data?.No_of_sitting}
                  onSave={(v) => handleFieldSave(["No_of_sitting"], v)}
                />
              </div>
              <div>
                <table>
                  <thead>
                    <tr>
                      <th>Subject</th>
                      <th>Grade</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getAtPath(data, [
                      "results",
                      "first_sitting",
                      "grade",
                    ])?.map((response, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <EditableField
                              value={response.subject}
                              onSave={(v) =>
                                handleFieldSave(
                                  [
                                    "results",
                                    "first_sitting",
                                    "grade",
                                    index,
                                    "subject",
                                  ],
                                  v,
                                )
                              }
                            />
                          </td>
                          <td>
                            <EditableField
                              value={response.grade}
                              onSave={(v) =>
                                handleFieldSave(
                                  [
                                    "results",
                                    "first_sitting",
                                    "grade",
                                    index,
                                    "grade",
                                  ],
                                  v,
                                )
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            {data?.No_of_sitting === "2" ? (
              <div className="fx-cl spacem">
                <h3>Second Sitting Result</h3>
                <div className="fx-ac">
                  <span>Number of Sitting:</span>
                  <EditableField
                    value={data?.No_of_sitting}
                    onSave={(v) => handleFieldSave(["No_of_sitting"], v)}
                  />
                </div>

                <div className="fx-cl space2">
                  <table>
                    <thead>
                      <tr>
                        <th>Subject</th>
                        <th>Grade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getAtPath(data, [
                        "results",
                        "second_sitting",
                        "grade",
                      ])?.map((response, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <EditableField
                                value={response.subject}
                                onSave={(v) =>
                                  handleFieldSave(
                                    [
                                      "results",
                                      "second_sitting",
                                      "grade",
                                      index,
                                      "subject",
                                    ],
                                    v,
                                  )
                                }
                              />
                            </td>
                            <td>
                              <EditableField
                                value={response.grade}
                                onSave={(v) =>
                                  handleFieldSave(
                                    [
                                      "results",
                                      "second_sitting",
                                      "grade",
                                      index,
                                      "grade",
                                    ],
                                    v,
                                  )
                                }
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null}
          </div>
        )}
        <div className="fx-cl space2">
          <h2>Uploaded Documents</h2>

          {adminPermission.fullControll && (
            <div className="g g2 rwdG2 space3">
              {getAtPath(data, ["documents"])?.map((response, index) => {
                return (
                  <figure key={index} className="fileUploadedCont g g2 space1">
                    <img
                      src={response.url}
                      alt="doc"
                      style={{ width: "7.3rem", height: "9rem" }}
                    />
                    <span className="fx-cl space1">
                      <span>
                        Name:{" "}
                        <EditableField
                          value={response?.fileName}
                          onSave={(v) =>
                            handleFieldSave(["documents", index, "fileName"], v)
                          }
                        />
                      </span>
                      <Link
                        className="neon-button fx-ac spacem"
                        to={`${response?.url}`}
                        style={{ color: "blue", maxWidth: "11rem" }}
                        target="blank"
                      >
                        <PrivacyTipOutlinedIcon
                          style={{ fontSize: "1.4rem", color: "#2a59a0" }}
                        />
                        <span>Preview</span>
                      </Link>
                    </span>
                  </figure>
                );
              })}
            </div>
          )}
        </div>

        <div
          className="updatingStudentDataPrcomp g g3 space2"
          style={{ borderTop: "1px solid #ccc", paddingTop: "1.5rem" }}
        >
          <div>
            <strong>Referee Name:</strong>{" "}
            <EditableField
              value={getAtPath(data, [
                "contactInfo",
                "refrees",
                "first_referee",
                "full_name",
              ])}
              onSave={(v) =>
                handleFieldSave(
                  ["contactInfo", "refrees", "first_referee", "full_name"],
                  v,
                )
              }
            />
          </div>
          <div>
            <strong>Refree Address:</strong>{" "}
            <EditableField
              value={getAtPath(data, [
                "contactInfo",
                "refrees",
                "first_referee",
                "address",
              ])}
              onSave={(v) =>
                handleFieldSave(
                  ["contactInfo", "refrees", "first_referee", "address"],
                  v,
                )
              }
            />
          </div>
          <div>
            <strong>Referee Phone No.:</strong>{" "}
            <EditableField
              value={getAtPath(data, [
                "contactInfo",
                "refrees",
                "first_referee",
                "phone",
              ])}
              onSave={(v) =>
                handleFieldSave(
                  ["contactInfo", "refrees", "first_referee", "phone"],
                  v,
                )
              }
            />
          </div>
          <div>
            <strong>Referee Name:</strong>{" "}
            <EditableField
              value={getAtPath(data, [
                "contactInfo",
                "refrees",
                "second_referee",
                "full_name",
              ])}
              onSave={(v) =>
                handleFieldSave(
                  ["contactInfo", "refrees", "second_referee", "full_name"],
                  v,
                )
              }
            />
          </div>
          <div>
            <strong>Refree Address:</strong>{" "}
            <EditableField
              value={getAtPath(data, [
                "contactInfo",
                "refrees",
                "second_referee",
                "address",
              ])}
              onSave={(v) =>
                handleFieldSave(
                  ["contactInfo", "refrees", "second_referee", "address"],
                  v,
                )
              }
            />
          </div>
          <div>
            <strong>Refree Phone No.:</strong>{" "}
            <EditableField
              value={getAtPath(data, [
                "contactInfo",
                "refrees",
                "second_referee",
                "phone",
              ])}
              onSave={(v) =>
                handleFieldSave(
                  ["contactInfo", "refrees", "second_referee", "phone"],
                  v,
                )
              }
            />
          </div>
        </div>

        <div
          className="fx-cl space3"
          style={{
            backgroundColor: "#fff",
            padding: "1rem",
            borderRadius: ".8rem",
          }}
        >
          <div className="fx-cl fx-jc space1">
            <h2>Admin Notes</h2>
            <p>
              This section is for admin use only. Notes added here will not be
              visible to students and are meant for internal reference regarding
              the student's profile and any actions taken.
            </p>
          </div>
        </div>
        <div
          className="fx-cl space3"
          style={{
            backgroundColor: "#fff",
            padding: "1rem",
            borderRadius: ".8rem",
          }}
        >
          <div className="fx-cl fx-jc fx-ac space1">
            <h2>Delete Student</h2>
            <p className="fs5">
              Deleting a student profile is irreversible. Please ensure that you
              have backed up any necessary data before proceeding with the
              deletion of this student's profile.
            </p>
            {adminPermission.fullControll && (
              <button
                className="fx-ac spacem"
                style={{
                  backgroundColor: "#e52214",
                  width: "20rem",
                  color: "#fff",
                  textAlign: "center",
                }}
                onClick={() => deleteStudent(data?.admission_number)}
              >
                <DeleteForeverIcon fontSize="large" />
                <span style={{ fontSize: "1.4rem" }}>Delete</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
